import { formatFollowUpDates } from "./formatFollowUpDates";

/**
 * Validates and transforms an array of follow-up objects, ensuring no duplicates exist
 * and preparing them for final submission.
 */
export const validateFollowupWorkOrderDtos = (followups, duplicateWODtos, workOrderData) => {
    return followups.map((followup) => {
        // duplicateWODtos are fetched from sagas, if a followup doesnt have duplicateWODto record, means it wanst verified
        const hasWoDto = duplicateWODtos.find((wo) => wo.uuid === followup.uuid && wo.followUpTpyeId === followup.followUpTpyeId);
        const readyForFinalSubmit = followup.newWorkOrderRequired ? !!hasWoDto : true;
        return {
            uuid: followup.uuid,
            id: followup.id,
            followUpTpyeId: followup.followUpTpyeId,
            comments: followup.comments,
            creationDate: formatFollowUpDates(new Date()),
            taskId: workOrderData?.taskId ? workOrderData.taskId : null,
            dueDate: formatFollowUpDates(workOrderData.originalDueDate),
            overRidePriority: followup.overRidePriority,
            readyForFinalSubmit,
            ...(hasWoDto ? { duplicateWorkOrdersDTO: hasWoDto.duplicateWorkOrdersDTO, validatedForDoubles: true } : {}),
        };
    });
};
